export default {
  props: {
    action: {
      type: String,
    },
    async: {
      type: Boolean,
      default: false,
    },
    formId: {
      type: Number,
    },
    token: {
      type: String,
    },
    method: {
      type: String,
      default: 'POST'
    },
    serverErrors: {
      type: Object,
      default() {
        return {};
      }
    },
    serverAlerts: {
      type: Array,
      default() {
        return [];
      }
    },
    validate: {
      type: Boolean,
      default: true,
    },
    /**
     * Set to false to validate only on form submit.
     * Set to true to validate on input and blur.
     * Set to 'after' to validate on input and blur after first attempt.
     */
    validateOnChange: {
      type: [String, Boolean],
      default: 'after',
    }
  },
  data() {
    return {
      valid: true,
      attempts: 0,
      fields: [],
      errors: {},
      alerts: [],
    }
  },
  computed: {
    values() {
      return this.getValues();
    },
    labels() {
      return this.getLabels();
    },
    activeFields() {
      return this.fields.filter(field => {
        return field.enabled;
      });
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
    hasAlerts() {
      return this.alerts.length > 0;
    }
  },
  created() {
    this.valid = this.validateOnChange !== true;
    this.errors = this.serverErrors;
    this.alerts = this.serverAlerts;

    this.$root.$on('register-submit', this.registerSubmit);
  },
  mounted() {
    if (this.validate) {
      this.$refs.form.setAttribute('novalidate', true);
      this.$refs.form['novalidate'] = true;
    }
    this.$el.classList.remove("uk-hidden")
  },
  watch: {
    valid(isValid) {
      if (this.validateOnChange && this.$refs.submit) {
        this.$refs.submit.enabled = isValid;
      }
    },
  },
  methods: {
    onSubmit(e) {
      if (!this.validate) {
        this.submit();

        return;
      }
      if (this.performValidation()) {
        this.submit();
      } else {
        e.preventDefault();
      }
    },
    submit() {
      if (!this.async) {
        this.$refs.form.submit();
        return;
      }

      if (this.validate) {
        this.performValidation();
      }

      this.attempts++;
      //submit event
      this.$emit('submit', this);

      if (!this.valid) {
        return;
      }

      if (this.method.toLowerCase() === 'get') {
        return window.App.Axios.get(this.action, {params: this.values});
      }
      return window.App.Axios[this.method.toLowerCase()](this.action, this.values);
    },
    performFieldValidation(field) {
      return field.validateField(this.values, this.labels).valid;
    },
    performValidation() {

      this.valid = true;

      for (let i = 0; i < this.activeFields.length; i++) {
        if (!this.performFieldValidation(this.activeFields[i])) {
          this.valid = false;
        }
      }

      this.activeFields.forEach(field => {
        field.shouldValidate = true;
        if (this.validateOnChange && this.attempts === 0) {
          field.validateOnChange = true;
        }
      });

      window.App.$emit('form.validate', this);
      return this.valid;
    },

    registerSubmit(submit) {
      this.$refs.submit = submit;
    },

    registerField(field) {
      if (field.isMultipart) {
        this.$refs.form.setAttribute('enctype', 'multipart/form-data');
        this.$refs.form['enctype'] = 'multipart/form-data';
      }
      if (this.validateOnChange === true) {
        field.validateOnChange = true;
      }
      this.fields.push(field);
    },

    getValues() {
      let values = {};
      this.activeFields.forEach(field => {
        values[field.slug] = field.getValue();
      });

      return values;
    },

    setValues(values, merge = true) { //set to false to set empty values
      this.fields.forEach(field => {
        const value = values[field.slug];
        if (value || !merge) {
          field.setValue(value);
        }
      });
    },

    resetValues() {
      this.fields.forEach(field => {
        field.setValue(field.getDefaultValue());
      });
    },

    getValidations() {
      let validations = {};
      this.activeFields.forEach(field => {
        validations[field.slug] = field.getValidations();
      });

      return validations;
    },

    getLabels() {
      let labels = {};
      this.activeFields.forEach(field => {
        labels[field.slug] = field.getLabel();
      });

      return labels;
    },

    resetValidations() {
      this.errors = {};
      this.activeFields.forEach(field => {
        field.resetValidation();
      });
    }
  },
  provide: function () {
    return {
      register: this.registerField,
      validate: this.performValidation,
    };
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/mixins/Form.js